import * as tslib_1 from "tslib";
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, mergeMap, switchMap } from 'rxjs/operators';
import { Store, Select } from '@ngxs/store';
import { NbDialogService, NbMenuService, NbPopoverDirective } from '@nebular/theme';
// services
import { DeviceService } from '@app/models/devices/devices.service';
import { AppService } from '@app/app.service';
import { LocationService } from '@app/models/locations/locations.service';
import { NotificationService } from '@app/models/notifications/notifications.service';
import { UserService } from '@app/models/users/users.service';
// components
import { LocationSelectorComponent } from '@app/header/location-selector/component';
import { ConfirmComponent } from '@app/shared/confirm/component';
import { DataComponent } from '@app/utils/data.component';
// state
import { AuthState } from '@app/auth/auth.state';
import { ShowSelector, HeaderState, ChangeLocation } from '@app/header/header.state';
import { SetAvailableSpanTypes, SetSelectedSpanTypes } from '@app/state/query-state/query.state';
// utils
import { trackEvent } from '@app/utils/amplitude.utils';
// config
import { config } from '@config/config';
var INSTALLATION_RANK = {
    NOT_STARTED: 0,
    HOME_ADDED: 1,
    BRIDGE_ADDED: 2,
    SENSOR_ADDED: 3,
    BRIDGE_WIFI_CONNECTED: 4,
    DEVICES_CONNECTED: 5,
    METER_ENTERED: 6,
    DONE: 7,
};
export var LOCATION_SORT = function (locs, id) {
    locs.sort(function (a, b) {
        if (a.user_id === id && b.user_id !== id) {
            return -1;
        }
        else if (a.user_id !== id && b.user_id === id) {
            return 1;
        }
        else if (a.primary_location && !b.primary_location) {
            return -1;
        }
        else if (!a.primary_location && b.primary_location) {
            return 1;
        }
        else if (INSTALLATION_RANK[a.installation] > INSTALLATION_RANK[b.installation]) {
            return -1;
        }
        else if (INSTALLATION_RANK[a.installation] < INSTALLATION_RANK[b.installation]) {
            return 1;
        }
        return 0;
    });
    return locs;
};
var HeaderComponent = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderComponent, _super);
    function HeaderComponent(router, route, appService, locations, notifs, store, headerState, authState, dialogService, menuService, device, users) {
        var _this = _super.call(this, { refresh: 300000 }) || this;
        _this.router = router;
        _this.route = route;
        _this.appService = appService;
        _this.locations = locations;
        _this.notifs = notifs;
        _this.store = store;
        _this.headerState = headerState;
        _this.authState = authState;
        _this.dialogService = dialogService;
        _this.menuService = menuService;
        _this.device = device;
        _this.users = users;
        _this.loggedIn = false;
        _this.unreadNotifications = [];
        _this.unreadNotificationCount = 0;
        _this.deviceID = null;
        _this.additionalMenuItems = [
            {
                title: 'Change Location',
                icon: 'home',
            },
            {
                title: 'Find a Local Pro',
                icon: 'car',
            },
            {
                title: 'Settings',
                icon: 'settings',
            },
            {
                title: 'Logout',
                icon: 'close-square',
            },
        ];
        _this.entitlement = null;
        return _this;
    }
    HeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        // subscribe to the user entitlement status
        this.entitlementSubscription = this.users.getUserEntitlement().subscribe(function (entitlement) {
            if (entitlement) {
                _this.entitlement = entitlement;
            }
        });
        // gets number of unread notifications from subscription to service observable
        this.notifs.unreadNotifications.subscribe(function (unread) {
            if (unread) {
                _this.unreadNotificationCount = unread.length;
            }
            else {
                _this.unreadNotificationCount = null;
            }
            _this.unreadNotifications = unread;
        });
        // listens for clicks in the expanded option menu
        this.attachMenuListeners();
        this.router.events
            .pipe(filter(function (e) { return e instanceof NavigationEnd; }), map(function () {
            var route = _this.route;
            while (route.firstChild) {
                route = route.firstChild;
            }
            return route;
        }), filter(function (route) { return route.outlet === 'primary'; }), mergeMap(function (route) { return route.data; }))
            .subscribe(function (route) {
            _this.store.dispatch(new ShowSelector(!!route.locationSelector));
            // closes the notifications popover after navigating to a notification
            _this.popover.hide();
        });
        // gets the available location options for the user
        this.authState.emitAuthComplete().subscribe(function () {
            _this.loggedIn = true;
            _this.locationList = _this.locations.getAll({ list_shared: true, profile: true }).pipe(switchMap(function (res) { return _this.authState.getUser().pipe(map(function (user) { return ({ id: user.id, res: res }); })); }), map(function (data) { return LOCATION_SORT(data.res, data.id); }));
            _this.locationList.subscribe(function (locs) {
                var storedLoc = localStorage.getItem('location');
                var location;
                if (storedLoc) {
                    var loc = locs.filter(function (l) { return l.id === Number(storedLoc); });
                    location = loc[0] || locs[0];
                }
                else {
                    location = locs[0];
                }
                _this.store.dispatch(new ChangeLocation(location));
                // extract the span types in the usage profile and add to state
                _this.addActiveAppliancesToState(location);
            });
        });
        this.authState.emitAuthInvalid().subscribe(function () { return localStorage.removeItem('location'); });
        this.headerState.onChangeLocation().subscribe(function () {
            _this.getUnreadNotificationCount(_this.store.selectSnapshot(HeaderState.currentLocation).id);
            _this.appService.reloadData();
        });
    };
    HeaderComponent.prototype.ngOnDestroy = function () {
        if (this.entitlementSubscription) {
            this.entitlementSubscription.unsubscribe();
        }
    };
    HeaderComponent.prototype.getUnreadNotificationCount = function (id) {
        // this.getUnreadNotifications(id);
        this.notifs.getUnreadNotifications(id);
    };
    HeaderComponent.prototype.getUnreadNotifications = function (id) {
        var _this = this;
        this.notifs
            .getAll({ location_id: id, read: false })
            .pipe()
            .subscribe(function (data) {
            var _a;
            (_a = _this.unreadNotifications).push.apply(_a, tslib_1.__spread(data));
            _this.unreadNotificationCount = data.length;
        });
    };
    HeaderComponent.prototype.reduceUnreadCount = function () {
        if (this.unreadNotificationCount > 0) {
            this.unreadNotificationCount -= 1;
        }
    };
    HeaderComponent.prototype.resetUnreadCount = function () {
        this.unreadNotificationCount = 0;
    };
    HeaderComponent.prototype.hidePopover = function () {
        this.popover.hide();
    };
    HeaderComponent.prototype.goToCurrent = function () {
        this.router.navigate(['/dashboard']);
    };
    HeaderComponent.prototype.chooseLocation = function () {
        var _this = this;
        this.dialogService
            .open(LocationSelectorComponent, {
            context: {
                userID: this.authState.userID(),
                activeLoc: this.store.selectSnapshot(HeaderState.currentLocation).id,
                LOCATION_SORT: LOCATION_SORT,
            },
        })
            .onClose.subscribe(function (loc) {
            if (loc) {
                trackEvent('Header Location Changed', { id: loc.id, name: loc.name });
                _this.store.dispatch(new ChangeLocation(loc));
                _this.addActiveAppliancesToState(loc);
            }
        });
    };
    HeaderComponent.prototype.confirmLogout = function () {
        var _this = this;
        this.dialogService
            .open(ConfirmComponent, {
            context: {
                title: "Confirm Logout",
                content: 'Are you sure you want to logout?',
                confirmText: 'Yes, logout',
                confirmStatus: 'danger',
            },
        })
            .onClose.subscribe(function (logout) {
            if (logout) {
                _this.router.navigate(['/logout']);
            }
        });
    };
    HeaderComponent.prototype.attachMenuListeners = function () {
        var _this = this;
        this.menuService
            .onItemClick()
            .pipe(filter(function (_a) {
            var tag = _a.tag;
            return tag === 'add-menu';
        }), map(function (_a) {
            var icon = _a.item.icon;
            return icon;
        }))
            .subscribe(function (item) {
            switch (item) {
                case 'close-square':
                    _this.confirmLogout();
                    break;
                case 'home':
                    _this.chooseLocation();
                    break;
                case 'settings':
                    _this.router.navigate(['/settings']);
                    break;
                case 'car':
                    _this.router.navigate(['/local-pro']);
                    break;
                default:
                    _this.router.navigate(['/dashboard']);
                    break;
            }
        });
    };
    // compare the appliances in the usage profile with the appliances that are active in disagg and add to state
    HeaderComponent.prototype.addActiveAppliancesToState = function (location) {
        var _this = this;
        // if not using disagg features return default list of appliances
        if (!location.features.use_profile_for_disag || !location.profile) {
            // set the default list of appliances, starting with all
            var defaultAppliances = Object.keys(config.activeSpanTypes).reduce(function (acc, spanType) {
                if (config.activeSpanTypes[spanType] === true) {
                    acc.push({
                        field: spanType,
                        display: _this.capitalize(spanType),
                        value: true,
                    });
                }
                return acc;
            }, [
                {
                    field: 'all',
                    display: 'All Usage',
                    value: true,
                },
            ]);
            this.store.dispatch(new SetSelectedSpanTypes(['all']));
            this.store.dispatch(new SetAvailableSpanTypes(defaultAppliances));
        }
        else {
            var indoorAppliances = location.profile.indoor.reduce(function (acc, curr) {
                var temp = {};
                if (curr.field === 'water_softener') {
                    temp = {
                        field: 'softener',
                        display: 'Water Softener',
                        value: curr.value,
                    };
                }
                else {
                    temp = {
                        field: curr.field,
                        display: curr.display,
                        value: curr.value,
                    };
                }
                acc.push(temp);
                return acc;
            }, []);
            // add default indoor and outdoor types if they are present
            var indoor = this.checkIndoorOutdoor(indoorAppliances);
            var outdoor = this.checkIndoorOutdoor(location.profile.outdoor);
            var selectedAppliances = [
                {
                    field: 'all',
                    display: 'All Usage',
                    value: true,
                },
            ];
            if (outdoor) {
                selectedAppliances.push({
                    field: 'outdoor',
                    display: 'Outdoor',
                    value: true,
                });
            }
            if (indoor) {
                selectedAppliances.push({
                    field: 'indoor',
                    display: 'Indoor',
                    value: true,
                });
            }
            // add available additional appliances
            var activeSpanTypes_1 = config.activeSpanTypes;
            selectedAppliances.push.apply(selectedAppliances, tslib_1.__spread(tslib_1.__spread(indoorAppliances, location.profile.outdoor).filter(function (spanType) { return activeSpanTypes_1[spanType.field] === true && spanType.value === true; })));
            // set to state
            this.store.dispatch(new SetSelectedSpanTypes(['all']));
            this.store.dispatch(new SetAvailableSpanTypes(selectedAppliances));
        }
    };
    // check that at least one span type is true
    HeaderComponent.prototype.checkIndoorOutdoor = function (spanTypes) {
        return spanTypes.reduce(function (acc, curr) {
            if (curr.value === true) {
                acc = true;
            }
            return acc;
        }, false);
    };
    // capitalize string and remove underscores
    HeaderComponent.prototype.capitalize = function (str) {
        return str
            .split('_')
            .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
            .join(' ');
    };
    tslib_1.__decorate([
        Select(HeaderState.selectorShown),
        tslib_1.__metadata("design:type", Observable)
    ], HeaderComponent.prototype, "showSelector$", void 0);
    tslib_1.__decorate([
        Select(HeaderState.currentLocation),
        tslib_1.__metadata("design:type", Observable)
    ], HeaderComponent.prototype, "currentLocation$", void 0);
    return HeaderComponent;
}(DataComponent));
export { HeaderComponent };
